module.exports = __webpack_public_path__ + "img/linkedin-icon.41fac2d1.svg";